{
   "templates": {
      "termsAndConditions": "условия за ползване",
      "privacyPolicy": "политика за поверителност"
   },
   "common": {
      "email": "имейл",
      "password": "парола",
      "currentPassword": "текуща парола",
      "newPassword": "нова парола",
      "confirmPassword": "потвърди паролата",
      "name": "име",
      "fullName": "пълно име",
      "phone": "телефонен номер",
      "description": "описание",
      "color": "цвят",
      "or": "или",
      "of": "от",
      "step": "стъпка",
      "continue": "продължи",
      "back": "назад",
      "save": "запази",
      "create": "създай",
      "edit": "редактирай",
      "share": "сподели",
      "property": "имот",
      "properties": "имоти",
      "workspace": "работно поле",
      "workspaces": "работни полета",
      "item": "елемента",
      "items": "елементи",
      "member": "член",
      "members": "членове",
      "enabled": "активиран",
      "disabled": "деактивиран",
      "open": "отвори",
      "cancel": "отказ",
      "list": "списък",
      "grid": "карти",
      "price": "цена",
      "maintenanceFee": "входна такса",
      "status": "статус",
      "area": "площ",
      "livingArea": "дневна",
      "landArea": "земя",
      "commonArea": "общи части",
      "bed": "спалня",
      "beds": "спални",
      "floor": "етаж",
      "floors": "етажи",
      "built": "построен",
      "notes": "бележки",
      "room": "стая",
      "rooms": "стаи"
   },
   "components": {
      "alert": {
         "info": {
            "title": "информация"
         },
         "success": {
            "title": "успешно"
         },
         "warning": {
            "title": "предупреждение"
         },
         "error": {
            "title": "проблем"
         }
      },
      "decorations": {
         "priceTrend": "промяна на цената",
         "property": {
            "address": "Черни Връх 52, София"
         },
         "totalTracked": "общо проследени",
         "family": "семейство петрови",
         "membersList": {
            "title": "членове на екипа",
            "description": "споделено с твоя екип",
            "description2": "споделено с",
            "member1": "ик",
            "member2": "мл",
            "member3": "сп"
         },
         "organizationName": "име на организацията"
      },
      "sideMenu": {
         "main": "основни",
         "dashboard": "табло",
         "companyProperties": "имоти на компанията",
         "trackedProperties": "проследени имоти",
         "workspaces": "работни пространства",
         "notifications": "нотификации",
         "account": "профил",
         "settings": "настройки",
         "support": "поддръжка"
      },
      "footer": {
         "productOf": "продукт на {brandName}",
         "copyright": "© {year} {brandName}. Всички права запазени."
      },
      "form": {
         "passwordRule": "поне 8 символа, едно число",
         "nothingToSave": "няма нищо за запазване все още"
      },
      "confirmationWrapper": {
         "title": "сигурни ли сте?",
         "message": "наистина ли искате да продължите? това действие може да бъде необратимо."
      },
      "workspaceModal": {
         "title": {
            "create": "създай работно поле",
            "edit": "редактирай работното поле"
         },
         "form": {
            "nameTooltip": "пример: Семейство Петрови"
         }
      },
      "workspaceShareModal": {
         "description": {
            "PERSONAL": "сподели с не повече от {membersLimit} хора",
            "AGENCY": "сподели с не повече от {membersLimit} външни хора. колеги могат да бъдат добавени директно"
         }
      },
      "propertyCard": {
         "menuActions": {
            "open": "отвори",
            "openInNewTab": "отвори в нов таб",
            "archive": "архивирай",
            "delete": "изтрий"
         }
      }
   },
   "api": {
      "success": {
         "default": "Успешно",
         "list": {
            "userRegistered": "потребителят е регистриран",
            "userLoggedIn": "потребителят влезе",
            "userLoggedOut": "потребителят излезе",
            "userUpdated": "потребителят е обновен",
            "accountDeleted": "акаунтът е изтрит",
            "emailVerificationSent": "имейл за потвърждение е изпратен",
            "profileImageUpdated": "профилната снимка е запазена",
            "passwordChanged": "паролата е променена",
            "passwordSet": "паролата е зададена",
            "organizationCreated": "организацията е създадена",
            "organizationEdited": "организацията е редактирана",
            "propertyEdited": "имотът е редактиран",
            "propertyArchived": "имотът е архивиран",
            "propertyUnarchived": "имотът е възстановен",
            "workspaceCreated": "работното поле е създаден",
            "workspaceEdited": "работното поле е редактирано",
            "workspaceArchived": "работното поле е архивирано",
            "workspaceUnarchived": "работното поле е възстановено",
            "workspaceShareLinkCreated": "линк за сподемяне на работното поле е възстановен"
         }
      },
      "warnings": {
         "default": "Предупреждение",
         "list": {
            "logInAgainToDeleteAccount": "моля, влезте отново, за да изтриете акаунта си",
            "logInAgainToChangePassword": "моля, влезте отново, за да промените паролата си",
            "cannotChangePassword": "не може да се промени паролата"
         }
      },
      "errors": {
         "default": "нещо се обърка",
         "server": "проблем със сървъра",
         "notFound": "не е намерено",
         "list": {
            "cannotSendEmailVerification": "не може да се изпрати имейл за потвърждение",
            "cannotUpdateUserData": "не може да се запазят потребителските данни",
            "cannotUpdateUserDataDescription": "появи се проблем при запазването на потребителските данни. моля, опитайте отново по-късно.",
            "auth/claims-too-large": "появи се проблем с потребителя",
            "auth/email-already-exists": "имейлът вече съществува",
            "auth/id-token-expired": "сесията на потребителя изтече",
            "auth/id-token-revoked": "сесията на потребителя изтече",
            "auth/insufficient-permission": "появи се проблем с потребителя",
            "auth/internal-error": "появи се проблем с потребителя",
            "auth/invalid-argument": "появи се проблем с потребителя",
            "auth/invalid-claims": "появи се проблем с потребителя",
            "auth/invalid-continue-uri": "появи се проблем с потребителя",
            "auth/invalid-creation-time": "появи се проблем с потребителя",
            "auth/invalid-credential": "данните за вход/регистрация не са валидни",
            "auth/invalid-disabled-field": "появи се проблем с потребителя",
            "auth/invalid-display-name": "името не е валидно",
            "auth/invalid-dynamic-link-domain": "появи се проблем с потребителя",
            "auth/invalid-email": "имейлът не е валиден",
            "auth/invalid-email-verified": "имейлът потвърждението има проблем",
            "auth/invalid-hash-algorithm": "появи се проблем с потребителя",
            "auth/invalid-hash-block-size": "появи се проблем с потребителя",
            "auth/invalid-hash-derived-key-length": "появи се проблем с потребителя",
            "auth/invalid-hash-key": "появи се проблем с потребителя",
            "auth/invalid-hash-memory-cost": "появи се проблем с потребителя",
            "auth/invalid-hash-parallelization": "появи се проблем с потребителя",
            "auth/invalid-hash-rounds": "появи се проблем с потребителя",
            "auth/invalid-hash-salt-separator": "появи се проблем с потребителя",
            "auth/invalid-id-token": "появи се проблем с потребителя",
            "auth/invalid-last-sign-in-time": "появи се проблем с потребителя",
            "auth/invalid-page-token": "появи се проблем с потребителя",
            "auth/invalid-password": "паролата не е валидна",
            "auth/invalid-password-hash": "паролата не е валидна",
            "auth/invalid-password-salt": "паролата не е валидна",
            "auth/invalid-phone-number": "телефонният номер не е валиден",
            "auth/invalid-photo-url": "появи се проблем с потребителя",
            "auth/invalid-provider-data": "появи се проблем с потребителя",
            "auth/invalid-provider-id": "появи се проблем с потребителя",
            "auth/invalid-oauth-responsetype": "появи се проблем с потребителя",
            "auth/invalid-session-cookie-duration": "появи се проблем с потребителя",
            "auth/invalid-uid": "появи се проблем с потребителя",
            "auth/invalid-user-import": "появи се проблем с потребителя",
            "auth/maximum-user-count-exceeded": "появи се проблем с потребителя",
            "auth/missing-android-pkg-name": "появи се проблем с потребителя",
            "auth/missing-continue-uri": "появи се проблем с потребителя",
            "auth/missing-hash-algorithm": "появи се проблем с потребителя",
            "auth/missing-ios-bundle-id": "появи се проблем с потребителя",
            "auth/missing-uid": "появи се проблем с потребителя",
            "auth/missing-oauth-client-secret": "появи се проблем с потребителя",
            "auth/operation-not-allowed": "появи се проблем с потребителя",
            "auth/phone-number-already-exists": "телефонният номер вече съществува",
            "auth/project-not-found": "появи се проблем с потребителя",
            "auth/reserved-claims": "появи се проблем с потребителя",
            "auth/session-cookie-expired": "сесията на потребителя изтече",
            "auth/session-cookie-revoked": "сесията на потребителя изтече",
            "auth/too-many-requests": "Твърде много заявки. Опитай отново по-късно",
            "auth/uid-already-exists": "появи се проблем с потребителя",
            "auth/unauthorized-continue-uri": "появи се проблем с потребителя",
            "auth/user-disabled": "появи се проблем с потребителя",
            "auth/user-not-found": "появи се проблем с потребителя",
            "storage/unknown": "появи се проблем със съхранението",
            "storage/object-not-found": "появи се проблем със съхранението",
            "storage/bucket-not-found": "появи се проблем със съхранението",
            "storage/project-not-found": "появи се проблем със съхранението",
            "storage/quota-exceeded": "твърде много заявки. опитай отново по-късно",
            "storage/unauthenticated": "появи се проблем със съхранението",
            "storage/unauthorized": "появи се проблем със съхранението",
            "storage/retry-limit-exceeded": "твърде много заявки. опитай отново по-късно",
            "storage/invalid-checksum": "появи се проблем със съхранението",
            "storage/canceled": "действието е отменено",
            "storage/invalid-event-name": "появи се проблем със съхранението",
            "storage/invalid-url": "появи се проблем със съхранението",
            "storage/invalid-argument": "появи се проблем със съхранението",
            "storage/no-default-bucket": "появи се проблем със съхранението",
            "storage/cannot-slice-blob": "появи се проблем със съхранението",
            "storage/server-file-wrong-size": "появи се проблем със съхранението"
         }
      }
   },
   "enums": {
      "dayOfWeek": {
         "monday": "понеделник",
         "tuesday": "вторник",
         "wednesday": "сряда",
         "thursday": "четвъртък",
         "friday": "петък",
         "saturday": "събота",
         "sunday": "неделя"
      },
      "time": {
         "day": "ден",
         "month": "месец"
      },
      "countries": {
         "BG": "България"
      },
      "measurementUnit": {
         "metric": "метри",
         "imperial": "инчове"
      },
      "organizationType": {
         "PERSONAL": "лична организация",
         "AGENCY": "агенция"
      },
      "dealType": {
         "SALE": "продажба",
         "RENT": "наем"
      },
      "propertyAvailability": {
         "ACTIVE": "активен",
         "RESERVED": "резервиран",
         "SOLD": "продаден",
         "RENTED": "нает",
         "EXPIRED": "изтекъл",
         "TAKEN_DOWN": "премахнат",
         "UNKNOWN": "неизвестен"
      },
      "propertySpaceKind": {
         "PARKING_SPACE": "паркомясто",
         "GARAGE": "гараж",
         "BALCONY": "балкон",
         "LOGGIA": "лоджия",
         "TERRACE": "тераса",
         "ROOF_TERRACE": "тераса на покрива",
         "YARD": "двор",
         "BASEMENT": "маза",
         "STORAGE": "склад",
         "ATTIC": "таван",
         "BATHROOM": "баня",
         "BATHROOM_WITH_TOILET": "баня & тоалетна",
         "TOILET": "тоалетна",
         "POOL": "басейн",
         "SAUNA": "сауна",
         "WINTER_GARDEN": "зимна градина",
         "OTHER": "друго"
      },
      "propertySpacePlacement": {
         "UNDERGROUND": "под земята",
         "COVERED": "покрито",
         "OUTDOOR": "на открито",
         "INTERNAL": "на закрито",
         "UNKNOWN": "не се знае"
      },
      "propertySpaceSaleType": {
         "INCLUDED": "включено",
         "EXTRA_OPTIONAL": "по избор",
         "EXTRA_REQUIRED": "задължително допълнително",
         "UNKNOWN": "неизвестно"
      }
   },
   "pages": {
      "errorPage": {
         "home": "начало"
      },
      "auth": {
         "register": {
            "title": "създай своя профил",
            "description": "отнема по-малко от минута, не се изисква карта.",
            "createAccount": "създай профил",
            "agreeToText": "създавайки профил, се съгласявате с нашите {termsAndConditions} и {privacyPolicy}.",
            "alreadyHaveAccount": "вече имаш профил?"
         },
         "login": {
            "title": "добре дошли",
            "description": "влез, за да видите какво се е променило с вашите имоти.",
            "logIn": "влез",
            "doNotHaveAccount": "нямаш профил?"
         },
         "continueWithGoogle": "продължи с google",
         "marketingText": "проследявай всеки имот, който ти е важен, навсякъде, на едно място."
      },
      "organization": {
         "create": {
            "steps": {
               "1": {
                  "title": "как ще използваш",
                  "description": "Сега ще създадем твоята първа организация. можеш да създадеш други по-късно.",
                  "options": {
                     "PERSONAL": {
                        "title": "лично ползване",
                        "description": "проследявай имоти, които те интересуват и имаш интерес да закупиш или наемеш."
                     },
                     "AGENCY": {
                        "title": "агенция",
                        "description": "работи лесно със своите колеги и споделяй обяви с клиенти."
                     }
                  }
               },
               "2": {
                  "titlePersonal": "избери име за своя екип",
                  "title": "избери име за своята организация",
                  "description": "можеш да промениш името по всяко време от настройките.",
                  "namePersonal": "име на екипа",
                  "name": "име на организацията"
               },
               "3": {
                  "title": "покани своите колеги",
                  "description": "добави членове в организацията си, за да работиш заедно по обяви и папки с клиенти.",
                  "emailError": "Невалиден имейл"
               }
            },
            "submitButton": {
               "PERSONAL": "създай екипа & завърши",
               "AGENCY": "изпрати поканите & завърши"
            },
            "skip": "пропусни за сега",
            "marketingText": "покани своите колеги, за да видят всички обяви и папки с клиенти."
         }
      },
      "dashboard": {
         "title": "добре дошъл",
         "description": "ето какво се е променило във вашата организация"
      },
      "properties": {
         "title": {
            "PERSONAL": "проследени имоти",
            "AGENCY": "компания имоти"
         },
         "description": {
            "PERSONAL": "проследи и управлявай всички свои имоти в едно място",
            "AGENCY": "проследи и управлявай всички компании имоти в едно място"
         },
         "createWorkspace": "създай работно поле",
         "emptyStateMessage": "няма намерени имоти",
         "folderView": "папки",
         "flatList": "списък"
      },
      "notifications": {
         "title": "известия"
      },
      "addProperty": {
         "title": "проследи имот",
         "description": "постави линк към обява и ние автоматично ще попълним данните",
         "backButton": "откажи и се върни",
         "fields": {
            "url": "url към обявата",
            "urlError": "Невалиден url",
            "addTo": "добави към"
         },
         "submitButton": "започни проследяването",
         "scraping": {
            "steps": {
               "FETCHING": {
                  "title": "изтегляне на обявата",
                  "description": "изтегляме данните от обявата"
               },
               "READING": {
                  "title": "четене на данните",
                  "description": "анализираме обявата за важните данни"
               },
               "STRUCTURING": {
                  "title": "структуриране на данните",
                  "description": "организираме информацията в четим формат"
               },
               "FINALIZING": {
                  "title": "завършване",
                  "description": "приготвяме всичко за теб"
               }
            },
            "finish": {
               "title": "готови сме - имота е запазен",
               "description": "събрахме всички данни за имота и ги организирахме за теб"
            }
         },
         "actions": {
            "trackAnother": "проследи друг",
            "viewProperty": "виж имота",
            "tryAgain": "опитай отново"
         },
         "failed": {
            "title": "нещо се обърка",
            "description": "не успяхме да проучим имота. моля, опитай отново или се свържи с поддръжка."
         }
      },
      "singleProperty": {
         "trackedSince": "проследен от",
         "spaces": "помещения",
         "emptyStateMessage": "няма намерен имот"
      },
      "workspaces": {
         "title": "работни полета",
         "emptyStateMessage": "няма намерени работни полета"
      },
      "account": {
         "title": "акаунт",
         "logOut": "излез",
         "sections": {
            "account": {
               "memberSince": "член от",
               "profileImage": {
                  "remove": "махни снимката"
               }
            },
            "personalInfo": {
               "title": "лична информация",
               "description": "ъпдейтни личните си данни и информация за контакт.",
               "form": {
                  "emailInfoText": "за да промениш имейла си, свържи се с поддръжка."
               }
            },
            "signInSecurity": {
               "title": "вход & сигурност",
               "description": "управлявай методите за вход и настройките за сигурност.",
               "providers": {
                  "google": "google",
                  "password": "имейл & парола",
                  "notSupported": "неподдържан метод"
               },
               "password": {
                  "change": {
                     "title": "промени паролата",
                     "submitButton": "ъпдейтни паролата"
                  },
                  "set": {
                     "title": "задай парола",
                     "submitButton": "задай парола"
                  },
                  "errors": {
                     "passwordsDoNotMatch": "паролите не съвпадат"
                  }
               }
            },
            "dataPrivacy": {
               "title": "данни & поверителност",
               "items": {
                  "requestMyData": "заяви копие от данните ми",
                  "requestMyDataDescription": "ще получим отговор по имейл - това се обработва от нашия екип, а не директно изтегляне."
               },
               "contactSupport": "свържи се с поддръжка"
            },
            "deleteAccount": {
               "title": "изтрий акаунта",
               "description": "личната ти организация и всички агенции, които си създавал, ще бъдат архивирани заедно с теб. Бележките, които си писал по други проекти, остават като принадлежащи на \"изтрит потребител\".",
               "deleteButton": "изтрий акаунта"
            }
         }
      },
      "settings": {
         "title": "настройки",
         "sections": {
            "general": {
               "title": "общо",
               "description": "как се държи приложението",
               "fields": {
                  "weakStartDay": "начален ден на седмицата",
                  "weakStartDayDescription": "избери кой ден от седмицата да се счита за начален",
                  "measurementUnit": "мерна единица",
                  "measurementUnitDescription": "площите и разстоянията се конвертират само при показване"
               }
            },
            "appearance": {
               "title": "външен вид",
               "description": "персонализирай външния вид на приложението",
               "fields": {
                  "language": "език",
                  "languageDescription": "избери предпочитания от вас език за интерфейса"
               }
            },
            "notifications": {
               "title": "уведомления",
               "description": "управлявай предпочитанията за уведомления",
               "headers": {
                  "event": "събитие",
                  "inApp": "в приложението",
                  "email": "имейл"
               },
               "events": {
                  "priceChanges": "промени в цените",
                  "priceChangesDescription": "когато цената на следения имот се промени",
                  "availabilityChanges": "промени в наличността",
                  "availabilityChangesDescription": "важни промени в статуса като продаден, наемен, резервиран, изтекъл и други",
                  "activityDigest": "резюме на активността",
                  "activityDigestDescription": "резюме на твоята активност веднъж седмично"
               }
            },
            "organization": {
               "title": "организация",
               "description": "управлявай настройките на организацията",
               "form": {
                  "fields": {
                     "organizationName": "име на организацията",
                     "contactEmail": "имейл за контакт",
                     "contactPhone": "телефон за контакт",
                     "website": "уебсайт url"
                  }
               }
            }
         }
      },
      "support": {
         "title": "поддръжка"
      }
   }
}
